/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import { toggleModal } from '../../actions/ViewController';
import { logout } from '../../actions/ClientData';
import { SERVER_URL, LANDING_PAGE_URL } from '../../config';
import { modalTypes } from '../../consts';

class Header extends Component {
    constructor(props) {
        super(props);

        this.handleRegister = this.handleRegister.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
    }

    handleRegister() {
        this.props.toggleModal('authModal', modalTypes.SIGNUP);
    }

    handleLogin() {
        this.props.toggleModal('authModal', modalTypes.LOGIN);
    }

    handleLogout() {
        this.props.logout();
    }

    render() {
        const renderCompanyInfo = () =>
            this.props.userInfo.logo != null ? (
                <a href={`${LANDING_PAGE_URL}/`} className="with-logo">
                    <img src={this.props.userInfo.logo} />
                    {this.props.userInfo.company_name}
                </a>
            ) : (
                <a href={`${SERVER_URL}/`}>
                    {this.props.userInfo.company_name}
                </a>
            );

        return (
            <div>
                <header className="visible-xs-flex white">
                    <img
                        alt="Logo"
                        className="logo logo--purple"
                        src="/static/images/logo-purple.png"
                    />
                    {this.props.loggedIn ? (
                        <ul>
                            <li className="company-info">
                                {renderCompanyInfo()}
                            </li>
                            <li>
                                <a href={`${SERVER_URL}/account/logout`}>
                                    Log out
                                </a>
                            </li>
                        </ul>
                    ) : (
                        <ul>
                            <li>
                                <a href={`${SERVER_URL}/app`}>Get the app</a>
                            </li>
                            <li>
                                <a onClick={this.handleLogin}>Log in</a>
                            </li>
                        </ul>
                    )}
                </header>
                <header className="hidden-xs">
                    <img
                        alt="Logo"
                        className="logo logo--purple"
                        src="/static/images/logo-purple.png"
                    />
                    {this.props.loggedIn ? (
                        <ul>
                            <li>
                                <Link to="/jobs/list/">My bookings</Link>
                            </li>
                            <li>{renderCompanyInfo()}</li>
                            <li>
                                <a href={`${SERVER_URL}/account/logout`}>
                                    Log out
                                </a>
                            </li>
                        </ul>
                    ) : (
                        <ul>
                            <li>
                                <a href={`${SERVER_URL}/freelancer/signup`}>
                                    Become a BuzzWorker
                                </a>
                            </li>
                            <li>
                                <a onClick={this.handleRegister}>Register</a>
                            </li>
                            <li>
                                <a onClick={this.handleLogin}>Log in</a>
                            </li>
                        </ul>
                    )}
                </header>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loggedIn: state.clientData.loggedIn,
        userInfo: state.clientData.basicInfo,
    };
}

export default connect(mapStateToProps, { toggleModal, logout })(Header);
